import React, { createContext, useState } from "react";
import { getSellerByEmpCode } from "../Services/e-pro/SupplierService";
import { useHistory } from "react-router";
import { clearLocalStorageOnLogout } from "../Helper/localStoreFunction";

type Props = {
  children: React.ReactChild;
};

export enum GroupPermission {
  Pending = "Pending",
  AVLA = "AVLA",
  AVLB = "AVLB",
  AVLC = "AVLC",
}

export interface PermissionType {
  group: "AVLA" | "AVLB" | "AVLC" | "Pending";
  sellerType: "LegalEntity" | "Individual";
  sidebar: {
    name: string;
    sub: { key: string; name: string; url: string }[];
  }[];
}

export let innitialPermissionAVLC: PermissionType = {
  group: "AVLC",
  sellerType: "LegalEntity",
  sidebar: [
    {
      name: "ที่ต้องดำเนินการ",
      sub: [{ key: "petition", name: "คำร้อง", url: "" }],
    },
    {
      name: "สินค้าบน E-catalog",
      sub: [
        { key: "order-history", name: "ประวัติสั่งซื้อ", url: "" },
        { key: "my-products", name: "สินค้าของฉัน", url: "" },
        { key: "new-products", name: "เพิ่มสินค้าใหม่", url: "" },
        { key: "tracking-product-status", name: "ติดตามสถานะสินค้า", url: "" },
      ],
    },
    {
      name: "ข้อมูลผู้ค้า",
      sub: [{ key: "company-details", name: "รายละเอียดบริษัท", url: "" }],
    },
  ],
};

export let innitialPermissionAVLA: PermissionType = {
  group: "AVLA",
  sellerType: "Individual",
  sidebar: [
    {
      name: "ที่ต้องดำเนินการ",
      sub: [{ key: "petition", name: "คำร้อง", url: "" }],
    },
    {
      name: "ข้อมูลผู้ค้า",
      sub: [{ key: "company-details", name: "รายละเอียดบริษัท", url: "" }],
    },
  ],
};
export let innitialPermissionAVLB: PermissionType = {
  group: "AVLB",
  sellerType: "Individual",
  sidebar: [
    {
      name: "ที่ต้องดำเนินการ",
      sub: [{ key: "petition", name: "คำร้อง", url: "" }],
    },
    {
      name: "ข้อมูลผู้ค้า",
      sub: [{ key: "company-details", name: "รายละเอียดบริษัท", url: "" }],
    },
  ],
};

export let innitialPermissionPending: PermissionType = {
  group: "Pending",
  sellerType: "Individual",
  sidebar: [
    {
      name: "ที่ต้องดำเนินการ",
      sub: [{ key: "petition", name: "คำร้อง", url: "" }],
    },
    {
      name: "ข้อมูลผู้ค้า",
      sub: [{ key: "company-details", name: "รายละเอียดบริษัท", url: "" }],
    },
  ],
};

interface innitialContext {
  permission: PermissionType | null;
}
export const RoleRedcrossPermission = createContext<innitialContext | null>(
  null
);

export const AuthRedcrossContext = (props: Props) => {
  const empCode = localStorage.getItem("employeeCode") || undefined;
  const history = useHistory();
  const getUserProfile = async () => {
    if (empCode) {
      const response = await getSellerByEmpCode(empCode);
      if (!response.data) {
        clearLocalStorageOnLogout();
        history.push("/");
      }
    }
  };
  React.useEffect(() => {
    getUserProfile();
  }, []);
  const checkUser = () => {
    const sellerStatus = localStorage.getItem("SellerStatus")
      ? localStorage.getItem("SellerStatus")
      : "";
    const sellerType = localStorage.getItem("SellerType")
      ? localStorage.getItem("SellerType")
      : "";

    console.log("sellerStatus = ", sellerStatus);
    console.log("sellerType = ", sellerType);

    if (sellerStatus === "AVL-C") {
      innitialPermissionAVLC.group = "AVLC";
      innitialPermissionAVLC.sellerType = sellerType as
        | "LegalEntity"
        | "Individual";
      return innitialPermissionAVLC;
    } else if (sellerStatus === "AVL-A") {
      innitialPermissionAVLA.group = "AVLA";
      innitialPermissionAVLA.sellerType = sellerType as
        | "LegalEntity"
        | "Individual";
      return innitialPermissionAVLA;
    } else if (sellerStatus === "AVL-B") {
      innitialPermissionAVLB.group = "AVLB";
      innitialPermissionAVLB.sellerType = sellerType as
        | "LegalEntity"
        | "Individual";
      return innitialPermissionAVLA;
    } else {
      innitialPermissionPending.group = "Pending";
      innitialPermissionPending.sellerType = sellerType as
        | "LegalEntity"
        | "Individual";
      return innitialPermissionPending;
    }
  };

  const [permission] = useState<PermissionType | null>(checkUser());

  return (
    <RoleRedcrossPermission.Provider value={{ permission }}>
      {props.children}
    </RoleRedcrossPermission.Provider>
  );
};

export default AuthRedcrossContext;
